import { motion } from 'framer-motion';
import { ArrowLeft, FileText, Shield, Scale, AlertCircle, Globe } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useI18n } from '../contexts/I18nContext';
import BottomNav from '../components/BottomNav';

const TermsPage = () => {
  const navigate = useNavigate();
  const { t } = useI18n();

  const sections = [
    { icon: FileText, color: 'blue', title: t('terms.acceptance_title'), content: t('terms.acceptance') },
    { icon: Shield, color: 'green', title: t('terms.account_title'), content: t('terms.account') },
    { icon: Scale, color: 'purple', title: t('terms.use_title'), content: t('terms.use') },
    { icon: Globe, color: 'orange', title: t('terms.availability_title'), content: t('terms.availability') },
    { icon: AlertCircle, color: 'red', title: t('terms.liability_title'), content: t('terms.liability') },
  ];

  const colorMap = { blue: 'bg-blue-100 text-blue-700', green: 'bg-green-100 text-green-700', purple: 'bg-purple-100 text-purple-700', orange: 'bg-orange-100 text-orange-700', red: 'bg-red-100 text-red-700' };

  return (
    <div className="w-full max-w-md mx-auto min-h-screen bg-[#F7F9FB] relative flex flex-col">
      <div className="p-6 pb-24 flex-1">
        <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.3 }}>
          <div className="flex items-center gap-4 mb-6">
            <button onClick={() => navigate(-1)} data-testid="back-button"
              className="w-10 h-10 bg-white rounded-full flex items-center justify-center shadow-sm active:scale-95 transition-transform">
              <ArrowLeft size={20} className="text-slate-900" />
            </button>
            <h1 className="text-3xl font-bold tracking-tight text-slate-900" style={{ fontFamily: 'Manrope, sans-serif' }}>{t('terms.title')}</h1>
          </div>

          <div className="bg-blue-50 p-4 rounded-xl mb-6">
            <p className="text-sm text-blue-900" style={{ fontFamily: 'Figtree, sans-serif' }}>{t('terms.updated')}</p>
          </div>

          <div className="space-y-4">
            {sections.map((s, i) => {
              const Icon = s.icon;
              return (
                <div key={i} className="bg-white p-5 rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.04)]">
                  <div className="flex items-center gap-3 mb-3">
                    <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${colorMap[s.color]}`}><Icon size={20} /></div>
                    <h2 className="text-lg font-semibold text-slate-900" style={{ fontFamily: 'Manrope, sans-serif' }}>{s.title}</h2>
                  </div>
                  <p className="text-sm text-slate-600 leading-relaxed" style={{ fontFamily: 'Figtree, sans-serif' }}>{s.content}</p>
                </div>
              );
            })}

            <div className="bg-white p-5 rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.04)]">
              <h2 className="text-lg font-semibold text-slate-900 mb-2" style={{ fontFamily: 'Manrope, sans-serif' }}>{t('terms.billing_title')}</h2>
              <ul className="space-y-2 text-sm text-slate-600" style={{ fontFamily: 'Figtree, sans-serif' }}>
                <li className="flex items-start gap-2"><span className="text-blue-600 mt-0.5 shrink-0">*</span>{t('terms.billing_1')}</li>
                <li className="flex items-start gap-2"><span className="text-blue-600 mt-0.5 shrink-0">*</span>{t('terms.billing_2')}</li>
                <li className="flex items-start gap-2"><span className="text-blue-600 mt-0.5 shrink-0">*</span>{t('terms.billing_3')}</li>
                <li className="flex items-start gap-2"><span className="text-blue-600 mt-0.5 shrink-0">*</span>{t('terms.billing_4')}</li>
              </ul>
            </div>

            <div className="bg-white p-5 rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.04)]">
              <h2 className="text-lg font-semibold text-slate-900 mb-2" style={{ fontFamily: 'Manrope, sans-serif' }}>{t('terms.termination_title')}</h2>
              <p className="text-sm text-slate-600 leading-relaxed" style={{ fontFamily: 'Figtree, sans-serif' }}>{t('terms.termination')}</p>
            </div>

            <div className="bg-gradient-to-br from-blue-50 to-emerald-50 p-5 rounded-2xl border border-blue-100">
              <h2 className="text-lg font-semibold text-slate-900 mb-2" style={{ fontFamily: 'Manrope, sans-serif' }}>{t('terms.contact_title')}</h2>
              <p className="text-sm text-slate-600" style={{ fontFamily: 'Figtree, sans-serif' }}>{t('terms.contact')}</p>
            </div>
          </div>
        </motion.div>
      </div>
      <BottomNav />
    </div>
  );
};

export default TermsPage;
